// import { BsPeopleFill } from "react-icons/bs";
// import { CgSandClock } from "react-icons/cg";
// import { FaChair } from "react-icons/fa";
// import { MdOutlineLunchDining } from "react-icons/md";
// import { PiBookOpenDuotone, PiNotepadDuotone } from "react-icons/pi";
// import { getLocalStorageItem } from "../Utils/Index"; // adjust path to match your project

// const allNavItems = [
//     {
//         to: "makeorder",
//         name: "CreateOrder",
//         icon: <FaChair />,
//     },
//     {
//         to: "menus",
//         name: "Items",
//         icon: <MdOutlineLunchDining />,
//     },
//     {
//         to: "staff",
//         name: "People",
//         icon: <BsPeopleFill />,
//     },
//     {
//         to: "sales",
//         name: "Sales",
//         icon: <PiBookOpenDuotone />,
//     },
//     {
//         to: "orders",
//         name: "Order",
//         icon: <CgSandClock />,
//     },
//     {
//         to: "order-status",
//         name: "Status",
//         icon: <PiNotepadDuotone />,
//     },
//     {
//         to: "plans",
//         name: "Plans",
//         icon: <PiNotepadDuotone />,
//     },
// ];

// export const getNavItems = () => {
//     let vendorId = null;
//     try {
//         const userDetail = JSON.parse(getLocalStorageItem("userDetail") || "{}");
//         vendorId = userDetail?.vendorId;
//     } catch {
//         vendorId = null;
//     }

//     const hasVendorId = vendorId !== null && vendorId !== undefined && vendorId !== "";

//     return allNavItems.filter((item) => {
//         if (item.to === "plans") {
//             return !hasVendorId; 
//         }
//         return true;
//     });
// };

// export const NavItems = allNavItems;
import { BsPeopleFill } from "react-icons/bs";
import { CgSandClock } from "react-icons/cg";
import { FaChair } from "react-icons/fa";
import { MdOutlineLunchDining } from "react-icons/md";
import { PiBookOpenDuotone, PiNotepadDuotone } from "react-icons/pi";
import { getLocalStorageItem } from "../Utils/Index";

const allNavItems = [
    { to: "makeorder", name: "CreateOrder", icon: <FaChair /> },
    { to: "menus", name: "Items", icon: <MdOutlineLunchDining /> },
    { to: "staff", name: "People", icon: <BsPeopleFill /> },
    { to: "sales", name: "Sales", icon: <PiBookOpenDuotone /> },
    { to: "orders", name: "Order", icon: <CgSandClock /> },
    { to: "order-status", name: "Status", icon: <PiNotepadDuotone /> },
    { to: "plans", name: "Plans", icon: <PiNotepadDuotone /> },
];

// Routes that should be hidden for a "service" role user with no vendorId
// (People, Sales — Plans and Setting are handled by their own rules below)
const SERVICE_RESTRICTED_ROUTES = ["staff", "sales"];

const getUserDetail = () => {
    try {
        const raw = getLocalStorageItem("userDetail");
        if (!raw) return null;

        // Handles both cases: helper returns a JSON string,
        // or helper already returns a parsed object.
        return typeof raw === "string" ? JSON.parse(raw) : raw;
    } catch (err) {
        console.error("Failed to read userDetail from local storage:", err);
        return null;
    }
};

const getVendorId = () => {
    const userDetail = getUserDetail();
    return userDetail?.vendorId ?? null;
};

const getRole = () => {
    const userDetail = getUserDetail();
    return userDetail?.role ?? null;
};

const isVendorIdMissing = (vendorId) =>
    vendorId === null || vendorId === undefined || vendorId === "";

export const getNavItems = () => {
    const vendorId = getVendorId();
    const role = getRole();

    const isVendorIdNull = isVendorIdMissing(vendorId);
    const isServiceWithoutVendor = role === "service" && isVendorIdNull;

    return allNavItems.filter((item) => {
        if (item.to === "plans") {
            // Plans shows only when vendorId is null AND the user isn't
            // a "service" role staff member.
            return isVendorIdNull && !isServiceWithoutVendor;
        }

        if (isServiceWithoutVendor && SERVICE_RESTRICTED_ROUTES.includes(item.to)) {
            return false;
        }

        return true;
    });
};

// Setting isn't part of allNavItems (it's rendered separately in the
// layout/drawer), so components check this to decide whether to show it.
export const shouldShowSetting = () => {
    const vendorId = getVendorId();
    const role = getRole();
    const isServiceWithoutVendor = role === "service" && isVendorIdMissing(vendorId);
    return !isServiceWithoutVendor;
};

export const NavItems = allNavItems;